export default __webpack_public_path__ + "static/media/steve-johnson-dVRD8E3XUGs-unsplash.c2e6d9f6.jpg";